export default {
  index: [
    {
      path: '/dpyjhdplan',
      component: resolve => require(['./dp_yjhdplanIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/dp_yjhdplan/_router.js